function initLifestylePP() {
  const lifestyleSwiperThumbs = new Swiper(".lifestyle-swiper-thumbs", {
    watchSlidesProgress: true,
    slidesPerView: 4,
    spaceBetween: 8,
    breakpoints: {
      490: {
        slidesPerView: 5,
      },
      590: {
        slidesPerView: 6,
      },
    },
  });
  const lifestyleSwiper = new Swiper(".lifestyle-swiper", {
    thumbs: {
      swiper: lifestyleSwiperThumbs,
    },
  });

  const variantPickerContainer = document.querySelector(
    ".lifestyle-variants form"
  );
  const comparetAtPriceElement = document.querySelector(
    ".lifestyle-actual-price"
  );
  const priceElement = document.querySelector(".lifestyle-compare-at-price");
  if (variantPickerContainer) {
    const atcButton = document.querySelector(".lifestyle-add-to-cart");
    const optionContainers = document.querySelectorAll(".option-container");
    const optionNames = [...optionContainers].map(
      (item) => item.dataset.optionName
    );

    const formState = {};
    updateLastOptions();

    const variantPickerInputs =
      variantPickerContainer.querySelectorAll("input");
    variantPickerInputs.forEach((input) => {
      input.addEventListener("change", () => {
        slideToSelectedVariant(input);
        updateFormState();
        updateLastOptions();
        updateAtcButton();
      });
    });

    function slideToSelectedVariant(input) {
      const optionName = input.closest(`div[data-option-name]`).dataset
        .optionName;
      if (
        !(
          optionName.toLowerCase() == "color" ||
          optionName.toLowerCase() == "colors"
        )
      )
        return;
      const image_id = input.dataset.imageId;
      if (!image_id) return;
      if (!lifestyleSwiper.slides || !Array.isArray(lifestyleSwiper.slides)) {
        return;
      }
      const slideIndex = lifestyleSwiper.slides.findIndex(
        (slide) => slide.dataset.imageId === image_id
      );
      if (slideIndex === -1) {
        return;
      }
      lifestyleSwiper.slideTo(slideIndex);
    }

    function updateLastOptions() {
      const clonedOptionNames = [...optionNames];
      clonedOptionNames.pop();

      const lastOptionName = optionNames[optionNames.length - 1];
      const lastOptionInputs = document.querySelectorAll(
        `.option-input[name='${lastOptionName}']`
      );
      const selectedInput = document.querySelector(
        `.option-input[name='${lastOptionName}']:checked`
      );
      lastOptionInputs.forEach((input, i, arr) => {
        const value = input.value;
        const selectedInputValues = clonedOptionNames.map(
          (item) => formState[item]
        );
        const variantTitle = [...selectedInputValues, value].join(" / ");
        const variant = lifestyleVariants.find((item) => {
          return item.title === variantTitle;
        });
        if (!variant || !variant?.available) {
          input.disabled = true;
          if (selectedInput.value === input.value) {
            lastOptionInputs[0].checked = true;
            updateFormState();
          }
        } else {
          input.disabled = false;
        }
      });
    }

    function updateFormState() {
      optionNames.forEach((item) => {
        const selectedInput = document.querySelector(
          `.option-input[name='${item}']:checked`
        );
        formState[item] = selectedInput.value;
      });
    }

    const priceFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: Shopify.currency.active,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    function updateAtcButton() {
      const variantTitle = Object.values(formState).join(" / ");
      const variant = lifestyleVariants.find(
        (item) => item.title == variantTitle
      );

      if (!variant) {
        console.error("can not find the variant");
        return;
      }
      comparetAtPriceElement.innerHTML = priceFormatter.format(
        variant.price / 100
      );

      if(variant.compare_at_price > variant.price) {
        priceElement.innerHTML = priceFormatter.format(
          variant.compare_at_price / 100
        );
      }
      
      atcButton.dataset.atc = variant.id;
      atcButton.dataset.selection = variant.title;
    }

    updateLastOptions();
  }

  const atcButton = document.querySelectorAll(".lifestyle-add-to-cart");
  atcButton.forEach((button) => {
    button.addEventListener("click", (e) => {
      const loader = button.querySelector(".loader-container");
      const text = button.querySelector(".text");
      loader.classList.remove("hidden");
      text.style.opacity = 0;

      const drawer = document.querySelector("custom-cart-drawer");

      const observer = new MutationObserver(() => {
        console.log(drawer.style.visibility);
        if (drawer.style.visibility === "visible") {
          loader.classList.add("hidden");
          text.style.opacity = 1;
          observer.disconnect();
        }
      });
      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ["style"],
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", initLifestylePP);
